export default "__VITE_ASSET__Czh0UNW0__"